import { render } from "./WowzaLicense.vue?vue&type=template&id=623ab980&scoped=true"
import script from "./WowzaLicense.vue?vue&type=script&lang=js"
export * from "./WowzaLicense.vue?vue&type=script&lang=js"

import "./WowzaLicense.vue?vue&type=style&index=0&id=623ab980&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623ab980"]])

export default __exports__